var jQuery = window.jQuery; // TODO: require("jquery");

jQuery(function () {
  jQuery.ajaxSetup({
    headers: {
      'X-CSRF-Token': jQuery('meta[name="csrf-token"]').attr('content')
    }
  });
});
